module.exports = __webpack_public_path__ + "img/Hollander_Joanne.dd3bc36e.jpg";